import { useCallback, useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { isNullOrUndefined } from "../utils/generalFunctions"
// import * as con from "../Constants"
import { setStoredValue } from "../store/actions"


export function RefStoredValue(key) {

    const value = useSelector(state => state[key])
    const [realValue, setRealValue] = useState(() => value === "null" || value === "undefined" || isNullOrUndefined(value) ? null : value)

    useEffect(() => {
        if (value === "null" || value === "undefined" || isNullOrUndefined(value))
            setRealValue(null)
        else
            setRealValue(value)

    }, [value])


    return (realValue);
}

export function StateStoredValue(key) {

    const value = RefStoredValue(key)

    const setValue = useCallback((value) => {
        setStoredValue(key, value)
    }, [key]);

    return ([value, setValue]);

}
